<template xmlns="http://www.w3.org/1999/html">
    <v-container grid-list-md>
        <v-layout wrap>
            <v-flex v-if="announcements.length === 0">
              <v-layout justify-center class="pt-5">
                <v-icon medium>notifications</v-icon>
                <span class="pl-5">No Announcements</span>
              </v-layout>
            </v-flex>
            <v-flex v-for="item in announcements" xs12 :key="item.id">
                <v-card :key="item.id" @click="show(item)" :class="{ 'bordered-card': !item.seenOn }">
                    <v-card-title>{{item.title}}</v-card-title>
                    <v-card-text>
                        <div class="subtitle">Published on {{item.publishedOn | formatDate}}</div>
                    </v-card-text>
                </v-card>
            </v-flex>
            <v-flex v-if="showMore">
                <v-layout justify-center class="pt-5">
                    <v-btn @click="loadMore">Load More</v-btn>
                </v-layout>
            </v-flex>
            <user-announcement-modal ref="announcement"></user-announcement-modal>
        </v-layout>
    </v-container>
</template>
<script>
import AnnouncementClient from '@/components/Announcements/AnnouncementClient.vue';
import UserAnnouncementModal from '@/components/Announcements/UserAnnouncementModal.vue';
import { Event, EventBus } from '@/plugins/bus';

export default {
  mixins: [AnnouncementClient],
  components: { UserAnnouncementModal },
  data() {
    return {
      announcements: [],
      page: 1,
      pageSize: 5,
      total: 0,
      loading: true,
      headers: [
        { text: 'Title', value: 'title' },
        { text: 'Created', value: 'createdOn' },
        { text: 'Published', value: 'publishedOn' },
      ]
    };
  },
  computed: {
    showMore() {
      return this.announcements.length < this.total;
    }
  },
  methods: {
    show(announcement) {
      this.$refs.announcement.show(announcement);
    },
    async load() {
      this.loading = true;
      const response = await this.getUserAnnouncements(this.page, this.pageSize);
      this.announcements = this.announcements.concat(response.data.map((announcement) => ({seenOn: null, ...announcement})));
      this.total = response.total || 0;
      this.loading = false;
    },
    loadMore() {
      this.page = this.page + 1;
      this.load();
    },
    async handleAnnouncementUpdated(item) {
      const found = this.announcements.find(a => a.id === item.id);
      let announcement = await this.getAnnouncement(item.id);

      if (!found) {
        this.announcements.push(item);
      } else {
        found.title = announcement.title;
        found.content = announcement.content;
        found.createOn = announcement.createOn;
        found.createBy = announcement.createBy;
        found.modifiedOn = announcement.modifiedOn;
        found.modifiedBy = announcement.modifiedBy;
        found.publishedOn = announcement.publishedOn;
        found.publishedBy = announcement.publishedBy;
        found.seenOn = announcement.seenOn;
      }
    },
    handleAnnouncementDeleted(item) {
      const index = this.announcements.findIndex(a => a.id === item.id);
      if (index === -1) {
        return;
      }

      this.announcements.splice(index, 1);
    }
  },
  async created() {
    await this.load();
    EventBus.$on(Event.AnnouncementUpdated, this.handleAnnouncementUpdated);
    EventBus.$on(Event.AnnouncementDeleted, this.handleAnnouncementDeleted);
  },
  destroyed() {
    EventBus.$off(Event.AnnouncementUpdated, this.handleAnnouncementUpdated);
    EventBus.$off(Event.AnnouncementDeleted, this.handleAnnouncementDeleted);
  }
};
</script>

<style scoped>
.subtitle {
    font-size: 0.75rem;
    color: rgba(0, 0, 0, 0.6); /* Adjust the color as needed */
    margin-bottom: 4px;
}
.bordered-card {
  border-left: 5px solid #375738; /* Adjust the width and color as needed */
  padding-left: 16px; /* Optional: Add padding to the content inside the card */
}
</style>
